import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'shared/components/Icon';

const NavOldLink = ({ id, to, label, icon }) => (
  <li className="btn">
    <a id={id} href={to}>
      <Icon name={icon} />
      <span className="text">{label}</span>
    </a>
  </li>
);

NavOldLink.displayName = 'NavOldLink';

NavOldLink.propTypes = {
  to: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
};

export default NavOldLink;
